import React from 'react';
import { useCollective } from '../context/CollectiveContext';
import ReserveSpot from '../components/ReserveSpot';
import HowItWorks from '../components/HowItWorks';
import WhyMailWorks from '../components/WhyMailWorks';
import Pricing from '../components/Pricing';
import Contact from '../components/Contact';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMapPin } = FiIcons;

export default function CollectivePage() {
  const collective = useCollective();
  if (!collective) return null;

  const { citySlug, label, v } = collective;

  return (
    <>
      {/* Hero — scoped to this collective */}
      <section className="min-h-screen bg-brand-dark flex items-center justify-center relative overflow-hidden pt-24">
        <div className="absolute inset-0 opacity-5 pointer-events-none">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] rounded-full blur-[140px]" style={{ backgroundColor: v.hex }} />
        </div>
        <div className="relative z-10 max-w-5xl mx-auto px-4 text-center">
          <div className="inline-flex items-center gap-2 text-white text-xs font-black uppercase tracking-widest px-4 py-1.5 rounded-full mb-6" style={{ backgroundColor: v.hex }}>
            <SafeIcon icon={FiMapPin} /> {label} · {v.label}
          </div>
          <h1 className="text-6xl md:text-8xl font-black text-white uppercase tracking-tighter italic leading-none mb-6">
            Fill Your<br />
            <span style={{ color: v.hex }}>Calendar.</span>
          </h1>
          <p className="text-xl md:text-2xl text-brand-cream/60 font-bold max-w-2xl mx-auto mb-10 leading-relaxed">
            {v.tagline} — one exclusive spot per category on a co-op direct mailer delivered to 5,000 homes in {label}.
          </p>
          <a
            href="#reserve"
            className="inline-block text-white font-black uppercase tracking-tight text-lg px-12 py-5 rounded-[2rem] transition-all hover:scale-105 active:scale-95 shadow-2xl"
            style={{ backgroundColor: v.hex }}
          >
            Claim Your Category
          </a>
        </div>
      </section>

      <HowItWorks />
      <WhyMailWorks />
      <ReserveSpot citySlug={citySlug} />
      <Pricing />
      <Contact />
    </>
  );
}
